
const vehicleData = window.HS_VEHICLE_DATA;
const pricingConfig = window.HS_PRICING_CONFIG;
const stageLogic = window.HS_STAGE_LOGIC;
const dynoGallery = window.HS_DYNO_GALLERY || [];

const STAGE_ORDER = {
  stage_1: 1,
  stage_2: 2,
  stage_2_plus: 3,
  stage_3: 4,
  stage_3_plus: 5,
  stage_4: 6,
  advice: 0
};

const advisorData = {
  steps: [
    {
      id: "brand",
      title: "Merk kiezen",
      intro: "Kies eerst alleen het automerk. Daarna tonen we pas de modellen die daarbij horen.",
      type: "options",
      multi: false,
      options: Object.entries(vehicleData.brands).map(([id, brand]) => ({
        id,
        label: brand.label,
        description: getBrandDescription(id)
      }))
    },
    {
      id: "car",
      title: "Selecteer het model",
      intro: "Selecteer het model waarvoor je de configuratie wilt samenstellen.",
      type: "options",
      multi: false,
      dynamicOptions: "modelOptions"
    },
    {
      id: "engine",
      title: "Motor inhoud kiezen",
      intro: "Kies de motorinhoud of uitvoering die bij de auto hoort.",
      type: "options",
      multi: false,
      dynamicOptions: "engineOptions"
    },
    {
      id: "transmission",
      title: "Versnellingsbak kiezen",
      intro: "Kies de versnellingsbak. De configurator toont alleen opties die technisch passen bij het gekozen model.",
      type: "options",
      multi: false,
      dynamicOptions: "transmissionOptions"
    },
    {
      id: "emissionStandard",
      title: "Emissienorm kiezen",
      intro: "Geef aan of jouw Abarth 500/595/695 Euro 5 of Euro 6 is. Dit bepaalt welke software-opties logisch zichtbaar zijn.",
      type: "options",
      multi: false,
      dynamicOptions: "emissionOptions",
      visibleForModel: "abarth_500_595_695"
    },
    {
      id: "goal",
      title: "Gewenste tuning kiezen",
      intro: "Kies de gewenste richting. De calculator beoordeelt daarna kritisch of die keuze logisch is.",
      type: "options",
      multi: false,
      dynamicOptions: "goalOptions"
    },
    {
      id: "extraOptions",
      title: "Meer opties kiezen",
      intro: "Selecteer extra opties die je wilt meenemen in de configuratie. Meerdere keuzes zijn mogelijk.",
      type: "options",
      multi: true,
      dynamicOptions: "extraOptions"
    },
    {
      id: "parts",
      title: "Huidige onderdelen kiezen",
      intro: "Wat zijn de huidige onderdelen op de auto? Meerdere keuzes zijn mogelijk.",
      type: "options",
      multi: true,
      dynamicOptions: "partOptions"
    },
    {
      id: "dyno",
      title: "Rollenbank kiezen",
      intro: "Rollenbankgebruik staat altijd los van de softwareprijs. Bij sommige stages is dit verplicht.",
      type: "options",
      multi: false,
      dynamicOptions: "dynoOptions"
    },
    {
      id: "technical",
      title: "Technische controle",
      intro: "Beantwoord deze vragen eerlijk. Bij technische risico's blokkeert de adviseur tuning en adviseert hij eerst controle of onderhoud.",
      type: "fields",
      fields: [
        { id: "mileage", label: "Kilometerstand", input: "text", placeholder: "Bijv. 84.000 km", required: true },
        { id: "fuel98", label: "Tank je 98 octaan?", input: "select", options: ["Ja", "Nee", "Onbekend"], required: true },
        { id: "maintenance", label: "Onderhoud up-to-date?", input: "select", options: ["Ja", "Nee", "Onbekend"] },
        { id: "warningLights", label: "Brandt het motormanagementlampje?", input: "select", options: ["Nee", "Ja", "Onbekend"] },
        { id: "engineRunsWell", label: "Loopt de motor netjes?", input: "select", options: ["Ja", "Nee", "Onbekend"] },
        { id: "leaksConsumption", label: "Lekkages of overmatig olie-/vloeistofverbruik?", input: "select", options: ["Nee", "Ja", "Onbekend"] },
        { id: "notes", label: "Technische opmerkingen", input: "textarea", placeholder: "Bijv. koppeling, turbo, lekkages of eerdere reparaties." }
      ]
    },
    {
      id: "advice",
      title: "Persoonlijk advies",
      intro: "Dit advies corrigeert technisch onlogische keuzes en toont softwareprijs, rollenbank en eventuele versnellingsbaksoftware apart.",
      type: "summary"
    },
    {
      id: "contact",
      title: "Contactformulier",
      intro: "Wil je meer informatie over de samengestelde setup, wil je een montage afspraak maken of heb je nog andere vragen? Stuur het formulier zo compleet mogelijk met informatie naar ons toe.",
      type: "fields",
      fields: [
        { id: "name", label: "Naam", input: "text", placeholder: "Volledige naam", required: true, contactName: "contact[name]" },
        { id: "licensePlate", label: "Kenteken", input: "text", placeholder: "Bijv. AB-123-C", required: true, contactName: "contact[kenteken]" },
        { id: "email", label: "E-mailadres", input: "email", placeholder: "naam@voorbeeld.nl", required: true, contactName: "contact[email]" },
        { id: "phone", label: "Telefoonnummer", input: "tel", placeholder: "+31 6 ...", required: true, contactName: "contact[phone]" },
        { id: "message", label: "Bericht", input: "textarea", placeholder: "Aanvullende wensen of vragen." }
      ]
    }
  ]
};

const state = {
  currentStep: 0,
  answers: {},
  submitError: ""
};

const stepLabel = document.querySelector("#step-label");
const wizardTitle = document.querySelector("#wizard-title");
const stepCounter = document.querySelector("#step-counter");
const progressBar = document.querySelector("#progress-bar");
const stepTabs = document.querySelector("#step-tabs");
const stepContent = document.querySelector("#step-content");
const advisorForm = document.querySelector("#advisor-form");
const prevButton = document.querySelector("#prev-button");
const nextButton = document.querySelector("#next-button");

function render() {
  if (isContactPosted()) {
    renderSubmittedThanks();
    return;
  }

  ensureCurrentStepIsVisible();
  const step = advisorData.steps[state.currentStep];
  const visibleSteps = getVisibleSteps();
  const visibleStepIndex = getVisibleStepIndex(state.currentStep);
  const progress = Math.round(((visibleStepIndex + 1) / visibleSteps.length) * 100);
  const currentStepComplete = isStepComplete(step);

  stepLabel.textContent = `Stap ${visibleStepIndex + 1} van ${visibleSteps.length}`;
  wizardTitle.textContent = getStepTitle(step);
  stepCounter.textContent = `${progress}%`;
  progressBar.style.width = `${progress}%`;

  renderTabs();
  renderStep(step);

  prevButton.disabled = state.currentStep === 0;
  prevButton.disabled = getAdjacentVisibleStepIndex(state.currentStep, -1) === state.currentStep;
  prevButton.hidden = false;
  nextButton.hidden = false;
  nextButton.disabled = !currentStepComplete;
  nextButton.textContent = step.id === "contact" ? "Verstuur aanvraag" : "Volgende";
}

function isContactPosted() {
  return new URLSearchParams(window.location.search).get("contact_posted") === "true";
}

function renderSubmittedThanks() {
  stepLabel.textContent = "Aanvraag verzonden";
  wizardTitle.textContent = "Bedankt voor je aanvraag";
  stepCounter.textContent = "100%";
  progressBar.style.width = "100%";
  stepTabs.innerHTML = "";
  stepContent.innerHTML = `<section class="thanks-panel" id="hs-corse-bedankt">
    <span class="thanks-panel__mark" aria-hidden="true">✓</span>
    <h3>Bedankt voor je aanvraag!</h3>
    <p>Je aanvraag is succesvol verstuurd. We nemen zo snel mogelijk contact met je op.</p>
  </section>`;
  prevButton.hidden = true;
  nextButton.hidden = true;
}

function renderTabs() {
  const visibleSteps = getVisibleSteps();
  const maxVisibleStepPosition = getMaxVisibleStepPosition();
  stepTabs.innerHTML = visibleSteps
    .filter((step, index) => index <= maxVisibleStepPosition)
    .map((step, index) => {
      const originalIndex = advisorData.steps.indexOf(step);
      const activeClass = originalIndex === state.currentStep ? " is-active" : "";
      const completeClass = isStepComplete(step) ? " is-complete" : "";
      return `<button class="step-tab${activeClass}${completeClass}" type="button" data-step="${originalIndex}" aria-label="${escapeHtml(getStepTitle(step))}">${index + 1}</button>`;
    })
    .join("");
}

function renderStep(step) {
  const intro = `<p class="step-intro">${escapeHtml(getStepIntro(step))}</p>`;

  if (step.type === "options") {
    stepContent.innerHTML = intro + renderOptions(step) + renderStepMessages(step);
    return;
  }

  if (step.type === "fields") {
    stepContent.innerHTML = intro + renderFields(step);
    return;
  }

  stepContent.innerHTML = intro + renderAdvice();
}

function renderOptions(step) {
  const selected = state.answers[step.id] || (step.multi ? [] : "");
  const options = getStepOptions(step);

  if (step.id === "parts") {
    return renderGroupedPartOptions(options, selected);
  }

  return `<div class="option-grid">
    ${options
      .map((option) => {
        const isSelected = step.multi ? selected.includes(option.id) : selected === option.id;
        return `<button class="option-card${isSelected ? " is-selected" : ""}" type="button" data-option="${escapeHtml(option.id)}">
          <strong>${escapeHtml(option.label)}</strong>
          <span>${escapeHtml(option.description)}</span>
        </button>`;
      })
      .join("")}
  </div>`;
}

function renderGroupedPartOptions(options, selected) {
  const groups = [
    ["Luchtinlaat", "air"],
    ["Downpipe", "downpipe"],
    ["Uitlaat", "exhaust"],
    ["Turbo", "turbo"],
    ["Injectoren", "injectors"],
    ["Intercooler", "intercooler"],
    ["Algemeen", "general"]
  ];

  return `<div class="part-category-list">
    ${groups.map(([label, groupId]) => {
      const groupOptions = options.filter((option) => getPartCategory(option.id) === groupId);
      if (!groupOptions.length) return "";

      return `<section class="part-category">
        <h3>${escapeHtml(label)}</h3>
        <div class="option-grid option-grid--compact">
          ${groupOptions.map((option) => {
            const isSelected = selected.includes(option.id);
            return `<button class="option-card${isSelected ? " is-selected" : ""}" type="button" data-option="${escapeHtml(option.id)}">
              <strong>${escapeHtml(option.label)}</strong>
              <span>${escapeHtml(option.description)}</span>
            </button>`;
          }).join("")}
        </div>
      </section>`;
    }).join("")}
  </div>`;
}

function renderFields(step) {
  const contactIntro = step.id === "contact" ? renderContactRequestSummary() : "";
  const contactHiddenFields = step.id === "contact" ? renderContactHiddenFields() : "";
  const requiredNote = step.fields.some((field) => field.required)
    ? `<p class="required-note">Velden met een * zijn verplicht.</p>`
    : "";

  return `${contactIntro}${requiredNote}<div class="field-grid">
    ${step.fields
      .map((field) => {
        const value = state.answers[field.id] || "";
        const fullClass = field.input === "textarea" ? " field--full" : "";
        const required = field.required ? " required" : "";
        const nameAttr = field.contactName ? ` name="${escapeHtml(field.contactName)}"` : "";

        if (field.input === "select") {
          return `<div class="field${fullClass}">
            <label for="${escapeHtml(field.id)}">${escapeHtml(getFieldLabel(field))}</label>
            <select id="${escapeHtml(field.id)}" data-field="${escapeHtml(field.id)}"${nameAttr}${required}>
              <option value="">Maak een keuze</option>
              ${field.options.map((option) => `<option value="${escapeHtml(option)}" ${value === option ? "selected" : ""}>${escapeHtml(option)}</option>`).join("")}
            </select>
          </div>`;
        }

        if (field.input === "textarea") {
          return `<div class="field${fullClass}">
            <label for="${escapeHtml(field.id)}">${escapeHtml(getFieldLabel(field))}</label>
            <textarea id="${escapeHtml(field.id)}" data-field="${escapeHtml(field.id)}" placeholder="${escapeHtml(field.placeholder || "")}"${nameAttr}${required}>${escapeHtml(value)}</textarea>
          </div>`;
        }

        return `<div class="field${fullClass}">
          <label for="${escapeHtml(field.id)}">${escapeHtml(getFieldLabel(field))}</label>
          <input id="${escapeHtml(field.id)}" type="${escapeHtml(field.input)}" data-field="${escapeHtml(field.id)}" placeholder="${escapeHtml(field.placeholder || "")}" value="${escapeHtml(value)}"${nameAttr}${required} />
        </div>`;
      })
      .join("")}
  </div>${contactHiddenFields}`;
}

function getFieldLabel(field) {
  return `${field.label}${field.required ? " *" : ""}`;
}

function renderContactRequestSummary() {
  const advice = stageLogic.calculateAdvice(state);
  const errorMessage = state.submitError ? `<div class="submit-error">${escapeHtml(state.submitError)}</div>` : "";

  return `<section class="contact-summary">
    <h3>Aanvraagoverzicht</h3>
    <p>Deze gegevens worden automatisch meegestuurd met het formulier, zodat H&amp;S Corse precies kan zien wat er is ingevuld.</p>
    <h4>Gekozen configuratie</h4>
    ${renderChoiceSummary()}
    <h4>Adviesresultaat</h4>
    <dl class="compact-summary">
      <dt>Aanbevolen stage</dt><dd>${escapeHtml(advice.stage || "Nog niet bepaald")}</dd>
      <dt>Verwacht vermogen</dt><dd>${escapeHtml(advice.power || "Nog niet bepaald")}</dd>
      <dt>Verwacht koppel</dt><dd>${escapeHtml(advice.torque || "Nog niet bepaald")}</dd>
      <dt>Status</dt><dd>${escapeHtml(advice.blocked ? "Niet goedgekeurd / aandacht nodig" : "Goedgekeurd / passend")}</dd>
    </dl>
    <h4>Technische controle</h4>
    ${renderTechnicalSummary()}
  </section>${errorMessage}`;
}

function renderContactHiddenFields() {
  return `<input type="hidden" name="return_to" value="${escapeHtml(getContactReturnToUrl())}" />
    <input type="hidden" name="contact[subject]" value="Nieuwe tuning configurator aanvraag" />
    <textarea class="visually-hidden" name="contact[body]" readonly>${escapeHtml(buildContactBody())}</textarea>`;
}

function getContactReturnToUrl() {
  const params = new URLSearchParams(window.location.search);
  params.set("contact_posted", "true");
  return `${window.location.pathname}?${params.toString()}#hs-corse-bedankt`;
}

function renderAdvice() {
  const advice = stageLogic.calculateAdvice(state);
  const requiredParts = advice.requiredParts.length ? renderPartList(advice.requiredParts, "required") : "<p>Geen extra onderdelen vereist voor dit advies.</p>";
  const missingParts = advice.missingParts.length ? renderPartList(advice.missingParts, "missing") : "<p>Alle benodigde onderdelen lijken aanwezig of zijn niet vereist voor deze stage.</p>";
  const warnings = advice.warnings.length ? renderList(advice.warnings, "warning-list") : "";
  const alternatives = advice.alternatives.length ? renderList(advice.alternatives) : "<p>De gekozen route is logisch voor deze setup.</p>";
  const matchingSetup = advice.matchingSetup ? renderMatchingSetup(advice.matchingSetup) : "";
  const setupIncomplete = advice.blocked && advice.missingParts.length > 0;
  const conclusionTitle = advice.blocked
    ? setupIncomplete
      ? "Helaas is je setup incompleet en kan hij nog niet worden afgesteld."
      : "Helaas is deze setup niet goedgekeurd voor de gekozen stage. Lees uitleg hieronder."
    : "Op basis van de ingevulde informatie, raden wij het volgende aan:";
  const conclusionBody = !advice.blocked && state.answers.goal === "advice"
    ? advice.explanation
    : advice.conclusion;

  return `<section class="advice-panel">
    <div class="result-hero ${advice.blocked ? "is-blocked" : "is-approved"}">
      <span class="advice-status ${advice.blocked ? "is-blocked" : "is-ok"}">${advice.blocked ? "Let op, jouw setup heeft nog wat aandacht nodig." : "Advies gereed"}</span>
      <h3>${escapeHtml(conclusionTitle)}</h3>
      ${advice.blocked ? "" : `<div class="recommended-stage">${escapeHtml(advice.stage)}</div>`}
      <p>${escapeHtml(conclusionBody)}</p>
    </div>

    <article class="advice-section">
      <div class="section-heading">
        <h4>Verwachte prestaties</h4>
        <span>${escapeHtml(advice.stage)}</span>
      </div>
      <div class="performance-grid">
        ${renderPerformanceMetric("Origineel vermogen", advice.originalPower)}
        ${renderPerformanceMetric("Na tuning", advice.power)}
        ${renderPerformanceMetric("Origineel koppel", advice.originalTorque)}
        ${renderPerformanceMetric("Na tuning", advice.torque)}
      </div>
    </article>

    <div class="advice-grid advice-grid--balanced">
      <article class="advice-section">
        <div class="section-heading">
          <h4>Benodigde onderdelen</h4>
          <span>${advice.missingParts.length ? "Aanvullen nodig" : "In orde"}</span>
        </div>
        ${requiredParts}
        <div class="missing-block">
          <h5>De onderdelen die nog ontbreken aan jouw setup</h5>
          ${missingParts}
        </div>
      </article>
      <article class="advice-section price-card">
        <div class="section-heading">
          <h4>Prijsindicatie</h4>
          <span>${escapeHtml(pricingConfig.taxMode)}</span>
        </div>
        ${renderPricing(advice.pricing)}
      </article>
    </div>

    ${warnings ? `<article class="advice-section advice-section--warning">
      <h4>Waarschuwingen</h4>
      ${warnings}
    </article>` : ""}

    <div class="advice-grid advice-grid--balanced">
      <article class="advice-section">
        <h4>Betere alternatieven</h4>
        ${alternatives}
      </article>
      <article class="advice-section">
        <h4>Gemaakte keuzes</h4>
        ${renderChoiceSummary()}
      </article>
    </div>

    ${renderDynoGallery()}

    ${matchingSetup}
  </section>`;
}

function renderMatchingSetup(setup) {
  return `<article class="advice-section advice-section--match">
    <div class="section-heading">
      <h4>Wat past wel bij de samengestelde setup?</h4>
      <span>${escapeHtml(setup.stage)}</span>
    </div>
    <p>${escapeHtml(setup.explanation)}</p>
    <div class="performance-grid performance-grid--compact">
      ${renderPerformanceMetric("Verwacht vermogen", setup.power)}
      ${renderPerformanceMetric("Verwacht koppel", setup.torque)}
    </div>
  </article>`;
}

function renderDynoGallery() {
  const images = dynoGallery.filter((image) => isDynoImageVisibleForSelection(image));
  if (!images.length) return "";

  return `<article class="advice-section dyno-gallery-section">
    <div class="section-heading">
      <h4>Voorbeelden van rollenbank uitdraaien</h4>
      <span>H&S Corse metingen</span>
    </div>
    <div class="dyno-gallery">
      ${images.map((image) => `<figure class="dyno-card">
        <button class="dyno-card__image" type="button" data-dyno-preview="${escapeHtml(image.id)}" aria-label="Bekijk ${escapeHtml(image.title || "rollenbank uitdraai")} groter">
          <img src="${escapeHtml(image.src)}" alt="${escapeHtml(image.title || "Rollenbank uitdraai")}" loading="lazy" />
        </button>
        <figcaption>
          <strong>${escapeHtml(image.title || "Rollenbank uitdraai")}</strong>
          ${image.caption ? `<span>${escapeHtml(image.caption)}</span>` : ""}
        </figcaption>
      </figure>`).join("")}
    </div>
  </article>`;
}

function isDynoImageVisibleForSelection(image) {
  if (image.active === false || !image.src) return false;
  if (image.modelId && image.modelId !== state.answers.car) return false;
  if (image.engineId && image.engineId !== state.answers.engine) return false;
  if (image.stageId && image.stageId !== state.answers.goal) return false;
  return true;
}

function openDynoPreview(imageId) {
  const image = dynoGallery.find((item) => item.id === imageId);
  if (!image) return;

  const preview = document.createElement("div");
  preview.className = "image-preview";
  preview.innerHTML = `
    <div class="image-preview__dialog" role="dialog" aria-modal="true" aria-label="${escapeHtml(image.title || "Rollenbank uitdraai")}">
      <button class="image-preview__close" type="button" data-close-preview aria-label="Sluiten">x</button>
      <img src="${escapeHtml(image.src)}" alt="${escapeHtml(image.title || "Rollenbank uitdraai")}" />
      <div class="image-preview__caption">
        <strong>${escapeHtml(image.title || "Rollenbank uitdraai")}</strong>
        ${image.caption ? `<span>${escapeHtml(image.caption)}</span>` : ""}
      </div>
    </div>
  `;
  document.body.append(preview);
}

function closeDynoPreview() {
  document.querySelector(".image-preview")?.remove();
}

function renderPricing(pricing) {
  const totalLabel = pricing.dynoRequired ? "Totaal" : "Totaal met gekozen opties";
  const totalWithoutDyno = pricingConfig.formatPrice(pricing.totalWithoutDyno);
  const totalWithDyno = pricingConfig.formatPrice(pricing.totalWithDyno);
  const total = pricingConfig.formatPrice(pricing.total);

  return `<div class="price-breakdown">
    ${pricing.priceError ? `<p class="price-error">${escapeHtml(pricing.priceError)}</p>` : ""}
    ${pricing.lines.map((line) => renderPriceLine(line)).join("")}
    ${pricing.dynoAllowed && !pricing.dynoRequired ? `<div class="price-line price-line--muted"><span>Totaal zonder rollenbank</span><strong>${escapeHtml(totalWithoutDyno)}</strong></div>` : ""}
    ${pricing.dynoAllowed && !pricing.dynoRequired ? `<div class="price-line price-line--muted"><span>Totaal met rollenbank</span><strong>${escapeHtml(totalWithDyno)}</strong></div>` : ""}
    <div class="price-line price-line--total"><span>${escapeHtml(totalLabel)}</span><strong>${escapeHtml(total)}</strong></div>
    <p>Softwareprijzen zijn exclusief montagekosten. Rollenbankgebruik staat altijd los vermeld als aparte prijsregel.</p>
  </div>`;
}

function renderPriceLine(line) {
  const value = line.suffix || pricingConfig.formatPrice(line.value);
  const prefix = typeof line.value === "number" && line.label.toLowerCase().includes("rollenbank") ? "+ " : "";
  return `<div class="price-line">
    <span>${escapeHtml(line.label)}</span>
    <strong>${escapeHtml(prefix + value)}</strong>
  </div>`;
}

function getStepOptions(step) {
  if (step.dynamicOptions === "modelOptions") return getModelOptions();
  if (step.dynamicOptions === "engineOptions") return getEngineOptions();
  if (step.dynamicOptions === "transmissionOptions") return getTransmissionOptions();
  if (step.dynamicOptions === "emissionOptions") return getEmissionOptions();
  if (step.dynamicOptions === "goalOptions") return getGoalOptions();
  if (step.dynamicOptions === "extraOptions") return getExtraOptions();
  if (step.dynamicOptions === "partOptions") return getPartOptions();
  if (step.dynamicOptions === "dynoOptions") return getDynoOptions();
  return step.options || [];
}

function renderStepMessages(step) {
  if (step.id !== "extraOptions") return "";
  const messages = getUnavailableOptionMessages();
  if (!messages.length) return "";

  return `<div class="option-message">
    ${messages.map((message) => `<p>${escapeHtml(message)}</p>`).join("")}
  </div>`;
}

function getModelOptions() {
  const selectedBrand = state.answers.brand;
  return Object.entries(vehicleData.models)
    .filter(([, model]) => !selectedBrand || model.brandId === selectedBrand)
    .map(([modelId, model]) => ({
      id: modelId,
      label: model.label,
      description: model.modelDescription
    }));
}

function getEngineOptions() {
  const model = vehicleData.models[state.answers.car];
  if (!model) return [];

  return model.engineIds.map((engineId) => {
    const engine = vehicleData.engines[engineId];
    return {
      id: engineId,
      label: engine.label,
      description: engine.description || model.engineQuestion || `Motorvariant voor ${model.label}.`
    };
  });
}

function getTransmissionOptions() {
  const model = vehicleData.models[state.answers.car];
  if (!model) return [];

  const transmissionIds = getAllowedTransmissionIds(model);
  return transmissionIds.map((transmissionId) => {
    const transmission = pricingConfig.transmissions[transmissionId];
    const dynoAllowed = isTransmissionDynoAllowed(transmissionId);
    return {
      id: transmissionId,
      label: transmission.label,
      description: dynoAllowed ? "Deze versnellingsbak kan op de rollenbank." : transmission.dynoBlockedMessage
    };
  });
}

function getEmissionOptions() {
  return [
    {
      id: "euro5",
      label: "Euro 5",
      description: "Abarth 500/595/695 bouwjaren 2008-2013."
    },
    {
      id: "euro6",
      label: "Euro 6",
      description: "Abarth 500/595/695 bouwjaren 2014-heden."
    },
    {
      id: "unknown",
      label: "Ik weet het niet",
      description: "H&S Corse beoordeelt dit aan de hand van bouwjaar, kenteken of voertuiggegevens."
    }
  ];
}

function getGoalOptions() {
  const hiddenForGiuliaStelvio = ["stage_3", "stage_3_plus", "stage_4"];
  return Object.entries(vehicleData.goals)
    .filter(([goalId]) => {
      if (["alfa_giulia", "alfa_stelvio"].includes(state.answers.car)) {
        return !hiddenForGiuliaStelvio.includes(goalId);
      }

      return true;
    })
    .map(([id, goal]) => ({
      id,
      label: goal.label,
      description: getGoalDescription(id)
    }));
}

function getExtraOptions() {
  const selectedStage = state.answers.goal || "advice";
  return Object.entries(vehicleData.extraOptions)
    .filter(([optionId]) => optionId !== "popsAndBangsDynamic" || supportsDynamicPops())
    .filter(([, option]) => !option.requiresTransmission || option.requiresTransmission === state.answers.transmission)
    .filter(([, option]) => !option.excludedModelIds || !option.excludedModelIds.includes(state.answers.car))
    .filter(([, option]) => !option.excludedEngineIds || !option.excludedEngineIds.includes(state.answers.engine))
    .filter(([, option]) => {
      const stageAllowed = selectedStage === "advice"
        || !option.availableFromStage
        || (STAGE_ORDER[selectedStage] ?? 0) >= (STAGE_ORDER[option.availableFromStage] ?? 0);
      const emissionAllowed = !option.requiresEmissionStandard || state.answers.emissionStandard === option.requiresEmissionStandard;
      return stageAllowed && emissionAllowed;
    })
    .map(([id, option]) => ({
      id,
      label: option.label,
      description: getExtraOptionDescription(id)
    }));
}

function supportsDynamicPops() {
  const engine = vehicleData.engines[state.answers.engine];
  return ["alfa_giulia", "alfa_stelvio"].includes(state.answers.car)
    || state.answers.engine === "alfa_giulietta_tjet_120_euro6"
    || (state.answers.car === "alfa_mito" && engine?.technology === "multiair");
}

function getPartOptions() {
  const selectedStage = state.answers.goal;
  const adviceRequested = selectedStage === "advice";
  const engineFamily = vehicleData.engines[state.answers.engine]?.family;
  const hybridSupported = vehicleData.performanceProfiles?.abarth_stage_2_plus_hybrid?.familyIds?.includes(engineFamily);
  const showHybridTurbo = (selectedStage === "stage_2_plus" || adviceRequested) && hybridSupported;
  const showGt1446Upgrade = (selectedStage === "stage_2_plus" || adviceRequested) && engineFamily === "abarth_ihi";
  const showTd04Gbc = (STAGE_ORDER[selectedStage] ?? 0) >= STAGE_ORDER.stage_3 || adviceRequested;

  return Object.entries(vehicleData.parts)
    .filter(([, part]) => !part.hidden)
    .filter(([, part]) => !part.modelIds || part.modelIds.includes(state.answers.car))
    .filter(([, part]) => !part.excludedModelIds || !part.excludedModelIds.includes(state.answers.car))
    .filter(([, part]) => !part.excludedEngineFamilies || !part.excludedEngineFamilies.includes(engineFamily))
    .filter(([, part]) => !part.engineTechnology || vehicleData.engines[state.answers.engine]?.technology === part.engineTechnology)
    .filter(([, part]) => !part.engineFamilies || part.engineFamilies.includes(engineFamily))
    .filter(([partId]) => partId !== "hybrid_turbo" || showHybridTurbo)
    .filter(([partId]) => partId !== "gt1446_upgrade" || showGt1446Upgrade)
    .filter(([partId]) => !["td04_turbo", "gbc_turbo"].includes(partId) || showTd04Gbc)
    .filter(([partId]) => partId !== "td04_gbc_turbo" || showTd04Gbc)
    .filter(([, part]) => adviceRequested || !part.stageIds || part.stageIds.includes(selectedStage))
    .filter(([, part]) => adviceRequested || !part.availableFromStage || (STAGE_ORDER[selectedStage] ?? 0) >= (STAGE_ORDER[part.availableFromStage] ?? 0))
    .filter(([, part]) => adviceRequested || !part.maxStage || (STAGE_ORDER[selectedStage] ?? 0) <= (STAGE_ORDER[part.maxStage] ?? 99))
    .map(([id, part]) => ({
      id,
      label: getPartLabel(id),
      description: getPartDescription(id)
    }));
}

function getPartCategory(partId) {
  if (["intake", "sport_filter"].includes(partId)) return "air";
  if (["downpipe_200", "open_downpipe"].includes(partId)) return "downpipe";
  if (["full_exhaust_635", "full_exhaust_70", "full_exhaust_76", "midpipe_635", "midpipe_70", "midpipe_76", "stage2_midpipe_635", "turismo_muffler", "sport_muffler", "alfa_sport_muffler", "abarth_124_sport_muffler", "gtech_muffler"].includes(partId)) return "exhaust";
  if (["td04_turbo", "gbc_turbo", "td04_gbc_turbo", "hybrid_turbo", "gt1446_upgrade", "alfa_hybrid_turbo", "k04_hybrid_stage1", "k04_hybrid_stage2", "k04_hybrid_turbo"].includes(partId)) return "turbo";
  if (["injectors_390cc"].includes(partId)) return "injectors";
  if (["intercooler", "standard_intercooler"].includes(partId)) return "intercooler";
  return "general";
}

function getUnavailableOptionMessages() {
  const messages = [];
  if (state.answers.car !== "abarth_500_595_695") return messages;

  if (state.answers.emissionStandard === "euro5") {
    messages.push("Pops & Bangs enkel onder sport is alleen mogelijk bij Euro 6 modellen.");
  }

  if (state.answers.emissionStandard === "unknown") {
    messages.push("Pops & Bangs enkel onder sport is alleen mogelijk bij Euro 6 modellen. We beoordelen dit aan de hand van het kenteken of de voertuiggegevens.");
  }

  return messages;
}

function getAllowedTransmissionIds(model) {
  if (state.answers.car === "alfa_giulietta" && vehicleData.engines[state.answers.engine]?.family === "alfa_giulietta_tjet_120") {
    return ["manual"];
  }
  if (state.answers.car === "alfa_giulietta" && state.answers.engine === "alfa_giulietta_1750_tbi_manual") {
    return ["manual"];
  }
  if (state.answers.car === "alfa_giulietta" && state.answers.engine === "alfa_giulietta_1750_tbi_tct") {
    return ["tct"];
  }
  return Array.isArray(model?.transmissionIds) && model.transmissionIds.length ? model.transmissionIds : ["manual"];
}

function isTransmissionDynoAllowed(transmissionId = state.answers.transmission || "manual") {
  if (transmissionId === "tct" && state.answers.car === "alfa_giulietta") {
    return state.answers.engine === "alfa_giulietta_1750_tbi_tct";
  }
  return pricingConfig.transmissions[transmissionId]?.dynoAllowed !== false;
}

function getDynoOptions() {
  const stageId = state.answers.goal || "advice";
  const transmission = pricingConfig.transmissions[state.answers.transmission || "manual"];
  const dynoRule = pricingConfig.dyno.rules[stageId] || "optional";
  const dynoPrice = getCurrentDynoPrice(stageId);

  if (transmission && !isTransmissionDynoAllowed()) {
    return [
      {
        id: "no",
        label: "Geen rollenbank",
        description: transmission.dynoBlockedMessage
      }
    ];
  }

  if (dynoRule === "required") {
    return [
      {
        id: "yes",
        label: "Rollenbank verplicht",
        description: `Voor ${vehicleData.goals[stageId]?.label || "deze keuze"} is rollenbankgebruik verplicht. Meerprijs: ${pricingConfig.formatPrice(dynoPrice)}.`
      }
    ];
  }

  return [
    {
      id: "no",
      label: "Geen rollenbank",
      description: "Alleen softwareprijs tonen. Rollenbank blijft optioneel."
    },
    {
      id: "yes",
      label: "Rollenbank toevoegen",
      description: `Optioneel rollenbankgebruik incl. uitdraai: + ${pricingConfig.formatPrice(dynoPrice)}.`
    }
  ];
}

function getCurrentDynoPrice(stageId = state.answers.goal || "stage_1") {
  const engine = vehicleData.engines[state.answers.engine];
  if (!engine) return pricingConfig.dyno.price;

  let vehicleId = engine.pricingVehicleId;
  let variantId = engine.pricingVariantId;
  if (state.answers.car === "abarth_500_595_695" && ["euro5", "euro6"].includes(state.answers.emissionStandard)) {
    vehicleId = "abarth595";
    variantId = state.answers.emissionStandard;
  }

  const priceResult = pricingConfig.calculateTotalPrice({
    vehicleId,
    variantId,
    stageId: pricingConfig.stageIdToPriceKey[stageId] || stageId,
    includeDyno: true,
    selectedExtras: []
  });

  return priceResult.dynoUnitPrice || pricingConfig.dyno.price;
}

function getStepTitle(step) {
  return step.title;
}

function getStepIntro(step) {
  return step.intro;
}

function renderChoiceSummary() {
  return `<dl class="compact-summary">
    ${getChoiceSummaryRows().map(([label, value]) => `<dt>${escapeHtml(label)}</dt><dd>${escapeHtml(value || "Nog niet ingevuld")}</dd>`).join("")}
  </dl>`;
}

function renderTechnicalSummary() {
  return `<dl class="compact-summary">
    ${getTechnicalSummaryRows().map(([label, value]) => `<dt>${escapeHtml(label)}</dt><dd>${escapeHtml(value || "Nog niet ingevuld")}</dd>`).join("")}
  </dl>`;
}

function getChoiceSummaryRows() {
  const rows = [
    ["Merk", vehicleData.brands[state.answers.brand]?.label],
    ["Model", vehicleData.models[state.answers.car]?.label],
    ["Motor inhoud", vehicleData.engines[state.answers.engine]?.label],
    ["Versnellingsbak", pricingConfig.transmissions[state.answers.transmission]?.label],
    ["Wens", vehicleData.goals[state.answers.goal]?.label],
    ["Extra opties", formatExtraOptions(state.answers.extraOptions)],
    ["Rollenbank", state.answers.dyno === "yes" ? "Ja" : "Nee"],
    ["Onderdelen", formatParts(state.answers.parts)]
  ];

  if (state.answers.car === "abarth_500_595_695") {
    rows.splice(4, 0, ["Emissienorm", getEmissionLabel(state.answers.emissionStandard)]);
  }

  return rows;
}

function buildContactBody() {
  const advice = stageLogic.calculateAdvice(state);
  const rows = getChoiceSummaryRows();
  const contactRows = [
    ["Naam", state.answers.name],
    ["Kenteken", state.answers.licensePlate],
    ["E-mailadres", state.answers.email],
    ["Telefoonnummer", state.answers.phone]
  ];
  const technicalRows = getTechnicalSummaryRows();

  return [
    "Nieuwe aanvraag via H&S Corse Tuning Configurator",
    "",
    "Contactgegevens",
    ...formatContactBodyRows(contactRows),
    "",
    "Configuratie",
    ...formatContactBodyRows(rows),
    "",
    "Adviesresultaat",
    `Aanbevolen stage: ${advice.stage || "Nog niet bepaald"}`,
    `Verwacht vermogen: ${advice.power || "Nog niet bepaald"}`,
    `Verwacht koppel: ${advice.torque || "Nog niet bepaald"}`,
    `Status: ${advice.blocked ? "Niet goedgekeurd / aandacht nodig" : "Goedgekeurd / passend"}`,
    "",
    "Benodigde onderdelen",
    ...(advice.requiredParts?.length ? advice.requiredParts.map((part) => `- ${part}`) : ["Geen extra onderdelen vermeld."]),
    "",
    "Onderdelen die nog ontbreken",
    ...(advice.missingParts?.length ? advice.missingParts.map((part) => `- ${part}`) : ["Geen ontbrekende onderdelen vermeld."]),
    "",
    "Waarschuwingen",
    ...(advice.warnings?.length ? advice.warnings.map((warning) => `- ${warning}`) : ["Geen waarschuwingen."]),
    "",
    "Technische controle",
    ...formatContactBodyRows(technicalRows),
    "",
    "Bericht van klant",
    state.answers.message || "Geen aanvullend bericht ingevuld."
  ].join("\n");
}

function formatContactBodyRows(rows) {
  return rows.map(([label, value]) => `${label}: ${value || "Niet ingevuld"}`);
}

function getTechnicalSummaryRows() {
  return [
    ["Kilometerstand", state.answers.mileage],
    ["Tank je 98 octaan?", state.answers.fuel98],
    ["Onderhoud up-to-date?", state.answers.maintenance],
    ["Motormanagementlampje", state.answers.warningLights],
    ["Motor loopt netjes", state.answers.engineRunsWell],
    ["Lekkages/verbruik", state.answers.leaksConsumption],
    ["Technische opmerkingen", state.answers.notes]
  ];
}

function updateOption(optionId) {
  const step = advisorData.steps[state.currentStep];
  const previousGoal = state.answers.goal;

  if (step.multi) {
    const selected = state.answers[step.id] || [];
    state.answers[step.id] = updateMultiSelect(step.id, selected, optionId);
  } else {
    state.answers[step.id] = optionId;
  }

  if (step.id === "goal" && previousGoal !== optionId) {
    state.answers.parts = (state.answers.parts || []).filter((partId) => !["hybrid_turbo", "td04_gbc_turbo", "td04_turbo", "gbc_turbo", "k04_hybrid_stage1", "k04_hybrid_stage2", "k04_hybrid_turbo", "turismo_muffler", "sport_muffler"].includes(partId));
  }

  if (step.id === "brand") {
    const selectedModel = vehicleData.models[state.answers.car];
    if (!selectedModel || selectedModel.brandId !== optionId) {
      state.answers.car = "";
      state.answers.engine = "";
      state.answers.transmission = "";
      state.answers.emissionStandard = "";
    }
  }

  if (step.id === "car") {
    const model = vehicleData.models[optionId];
    const engineIds = Array.isArray(model?.engineIds) ? model.engineIds : [];
    if (!engineIds.includes(state.answers.engine)) state.answers.engine = "";
    if (!getAllowedTransmissionIds(model).includes(state.answers.transmission)) state.answers.transmission = "";
    if (optionId !== "abarth_500_595_695") state.answers.emissionStandard = "";
  }

  if (step.id === "engine") {
    const model = vehicleData.models[state.answers.car];
    if (model && !getAllowedTransmissionIds(model).includes(state.answers.transmission)) {
      state.answers.transmission = "";
    }
  }

  if (["car", "engine", "transmission", "goal", "emissionStandard"].includes(step.id)) {
    const allowedGoals = getGoalOptions().map((option) => option.id);
    if (!allowedGoals.includes(state.answers.goal)) {
      state.answers.goal = "";
      state.answers.dyno = "";
    }

    const allowedExtras = getExtraOptions().map((option) => option.id);
    state.answers.extraOptions = (state.answers.extraOptions || []).filter((optionId) => allowedExtras.includes(optionId));

    const allowedParts = getPartOptions().map((option) => option.id);
    state.answers.parts = (state.answers.parts || []).filter((partId) => allowedParts.includes(partId));
  }

  if (["car", "engine", "goal", "transmission"].includes(step.id)) {
    const dynoOptions = getDynoOptions().map((option) => option.id);
    if (!dynoOptions.includes(state.answers.dyno)) {
      state.answers.dyno = dynoOptions[0] || "";
    }
  }

  render();
}

function updateField(fieldId, value) {
  state.answers[fieldId] = value;
}

function updateFieldControls() {
  const step = advisorData.steps[state.currentStep];
  if (step?.type !== "fields") return;

  if (step.id === "contact") {
    const bodyField = advisorForm.querySelector('[name="contact[body]"]');
    if (bodyField) {
      bodyField.value = buildContactBody();
    }
  }

  nextButton.disabled = !isStepComplete(step);
}

function updateContactControls() {
  const step = advisorData.steps[state.currentStep];
  if (step?.id !== "contact") return;

  const bodyField = advisorForm.querySelector('[name="contact[body]"]');
  if (bodyField) {
    bodyField.value = buildContactBody();
  }

  nextButton.disabled = !isStepComplete(step);
}

function submitContactForm() {
  const bodyField = advisorForm.querySelector('[name="contact[body]"]');
  if (bodyField) {
    bodyField.value = buildContactBody();
  }

  if (!advisorForm.reportValidity()) {
    return;
  }

  advisorForm.removeAttribute("target");
  advisorForm.submit();
}

function goToStep(index) {
  const maxVisibleStep = getMaxVisibleStepIndex();
  const targetIndex = Math.max(0, Math.min(index, maxVisibleStep));
  state.currentStep = isStepVisible(advisorData.steps[targetIndex])
    ? targetIndex
    : getClosestVisibleStepIndex(targetIndex, index >= state.currentStep ? 1 : -1);
  render();
}

function getBrandDescription(id) {
  const descriptions = {
    abarth: "Voor Abarth 500/595/695, Punto EVO, Grande Punto Abarth en Abarth 124.",
    alfa_romeo: "Voor Alfa MiTo, Giulietta, Giulia en Stelvio tuningadvies."
  };
  return descriptions[id] || "Selecteer dit merk.";
}

function getGoalDescription(id) {
  const descriptions = {
    stage_1: "Softwareoptimalisatie binnen een veilige en betrouwbare configuratie.",
    stage_2: "Vermogensupgrade met de benodigde ondersteunende hardware.",
    stage_2_plus: "Uitgebreidere configuratie met aanvullende upgrades voor meer prestaties en potentieel.",
    stage_3: "Complete turbo-upgrade met bijpassende componenten voor serieuze vermogenswinsten.",
    stage_3_plus: "Uitgebreid performanceproject met hoogwaardige hardware en een nog hoger prestatieniveau.",
    stage_4: "Volledig opgebouwd forged engine project voor maximale prestaties en de hoogste vermogensdoelen.",
    advice: "Laat de configurator de meest logische route kiezen."
  };
  return descriptions[id] || "";
}

function getExtraOptionDescription(id) {
  if (id === "popsAndBangs" && state.answers.car === "abarth_124_spider") {
    return "Pops & Bangs in alle standen / enkel in sport.";
  }

  const descriptions = {
    noExtraOptions: "Ik wil geen extra opties toevoegen.",
    popsAndBangs: vehicleData.extraOptions.popsAndBangs?.description || "In hardheid en duratie te programmeren.",
    popsAndBangsDynamic: vehicleData.extraOptions.popsAndBangsDynamic?.description || "Alleen actief in de rijmodus Dynamic.",
    mtaTuning: vehicleData.extraOptions.mtaTuning?.description || "Optionele softwareoptimalisatie voor de MTA-versnellingsbak.",
    popsAndBangsAbarthEuro6SportButton: vehicleData.extraOptions.popsAndBangsAbarthEuro6SportButton?.description || "Pops & Bangs gekoppeld aan sportmodus waar dit technisch past.",
    startStopDisable: "Start-stop functie softwarematig uitschakelen."
  };
  return descriptions[id] || "";
}

function getPartDescription(id) {
  const descriptions = {
    intake: "Aftermarket intake kit aanwezig.",
    sport_filter: "Sport inlegfilter aanwezig.",
    downpipe_200: "200 cells sportkat aanwezig.",
    open_downpipe: "Open sportdownpipe aanwezig.",
    full_exhaust_635: "Volledig 63,5 mm front-back uitlaatsysteem aanwezig.",
    full_exhaust_70: "Volledig 70 mm front-back uitlaatsysteem aanwezig.",
    full_exhaust_76: "Volledig 76mm (3 inch) front-to-back uitlaat aanwezig.",
    midpipe_635: "63,5 mm tussenbuis aanwezig.",
    midpipe_70: "70 mm tussenbuis aanwezig.",
    stage2_midpipe_635: "Stage 2 tussenbuis aanwezig, van 63,5 mm naar originele maat.",
    midpipe_76: "76mm tussenbuis aanwezig.",
    alfa_sport_muffler: "Sport einddemper aanwezig, bijvoorbeeld Ragazzon.",
    abarth_124_sport_muffler: "Sport einddemper aanwezig.",
    gtech_muffler: "Losse G-Tech einddemper aanwezig.",
    turismo_muffler: "Standaard Turismo einddemper aanwezig.",
    sport_muffler: "Sport einddemper aanwezig.",
    intercooler: "Verbeterde front mount intercooler aanwezig.",
    standard_intercooler: "Originele standaard intercooler aanwezig.",
    injectors_390cc: "390cc of 613cc injectoren aanwezig.",
    hybrid_turbo: "GT1446 Hybrid turbo aanwezig.",
    gt1446_upgrade: "GT1446 turbo-upgrade aanwezig of gewenst.",
    td04_turbo: "TD04 turbo aanwezig.",
    gbc_turbo: "GBC turbo aanwezig.",
    td04_gbc_turbo: "TD04 of GBC turbo aanwezig.",
    k04_hybrid_stage1: "K04 Hybrid Stage 1 turbo aanwezig.",
    k04_hybrid_stage2: "K04 Hybrid Stage 2 turbo aanwezig.",
    k04_hybrid_turbo: "K04 Hybrid Stage 1 of Stage 2 turbo aanwezig.",
    bov_adapter: "BOV-adapter aanwezig.",
    stock: "De auto is nog helemaal standaard."
  };
  return descriptions[id] || "";
}

function formatParts(partIds = []) {
  if (!partIds.length) return "";
  return partIds.map((partId) => getPartLabel(partId)).filter(Boolean).join(", ");
}

function getPartLabel(partId) {
  const part = vehicleData.parts[partId];
  if (!part) return "";
  if (partId === "sport_muffler") {
    return part.stageLabels?.[state.answers.goal] || part.label;
  }
  return part.modelLabels?.[state.answers.car] || part.label;
}

function formatExtraOptions(optionIds = []) {
  if (!optionIds.length) return "";
  return optionIds.map((optionId) => vehicleData.extraOptions[optionId]?.label).filter(Boolean).join(", ");
}

function getEmissionLabel(value) {
  const labels = {
    euro5: "Euro 5",
    euro6: "Euro 6",
    unknown: "Ik weet het niet"
  };

  return labels[value] || "";
}

function updateMultiSelect(stepId, selected, optionId) {
  if (stepId === "extraOptions") {
    if (optionId === "noExtraOptions") {
      return selected.includes(optionId) ? [] : [optionId];
    }

    const withoutNone = selected.filter((id) => id !== "noExtraOptions");
    const popsOptionIds = ["popsAndBangs", "popsAndBangsDynamic", "popsAndBangsAbarthEuro6SportButton"];
    if (popsOptionIds.includes(optionId)) {
      const withoutPops = withoutNone.filter((id) => !popsOptionIds.includes(id));
      return withoutNone.includes(optionId) ? withoutPops : [...withoutPops, optionId];
    }

    return withoutNone.includes(optionId)
      ? withoutNone.filter((id) => id !== optionId)
      : [...withoutNone, optionId];
  }

  if (stepId === "parts") {
    if (optionId === "stock") {
      return selected.includes(optionId) ? [] : [optionId];
    }

    const withoutStock = selected.filter((id) => id !== "stock");

    const intakeIds = ["intake", "sport_filter"];
    if (intakeIds.includes(optionId)) {
      const withoutOtherIntake = withoutStock.filter((id) => !intakeIds.includes(id));
      return withoutStock.includes(optionId) ? withoutOtherIntake : [...withoutOtherIntake, optionId];
    }

    const downpipeIds = ["downpipe_200", "open_downpipe"];
    if (downpipeIds.includes(optionId)) {
      const withoutDownpipe = withoutStock.filter((id) => !downpipeIds.includes(id));
      return withoutStock.includes(optionId) ? withoutDownpipe : [...withoutDownpipe, optionId];
    }

    const fullExhaustIds = ["full_exhaust_635", "full_exhaust_70", "full_exhaust_76"];
    const midpipeIds = ["midpipe_635", "midpipe_70", "midpipe_76", "stage2_midpipe_635"];
    const mufflerIds = ["turismo_muffler", "sport_muffler", "alfa_sport_muffler", "abarth_124_sport_muffler", "gtech_muffler"];
    const looseExhaustIds = [...midpipeIds, ...mufflerIds];
    if (fullExhaustIds.includes(optionId)) {
      const withoutOtherExhaust = withoutStock.filter((id) => !fullExhaustIds.includes(id) && !looseExhaustIds.includes(id));
      return withoutStock.includes(optionId) ? withoutOtherExhaust : [...withoutOtherExhaust, optionId];
    }

    if (looseExhaustIds.includes(optionId)) {
      const exclusiveMufflerIds = ["turismo_muffler", "sport_muffler"];
      const withoutFullExhaust = withoutStock
        .filter((id) => !fullExhaustIds.includes(id))
        .filter((id) => !midpipeIds.includes(optionId) || !midpipeIds.includes(id))
        .filter((id) => !exclusiveMufflerIds.includes(optionId) || !exclusiveMufflerIds.includes(id));
      return withoutStock.includes(optionId)
        ? withoutFullExhaust.filter((id) => id !== optionId)
        : [...withoutFullExhaust, optionId];
    }

    const turboIds = ["hybrid_turbo", "gt1446_upgrade", "td04_turbo", "gbc_turbo", "td04_gbc_turbo", "k04_hybrid_stage1", "k04_hybrid_stage2", "k04_hybrid_turbo"];
    if (turboIds.includes(optionId)) {
      const withoutTurbo = withoutStock.filter((id) => !turboIds.includes(id));
      return withoutStock.includes(optionId) ? withoutTurbo : [...withoutTurbo, optionId];
    }

    const intercoolerIds = ["intercooler", "standard_intercooler"];
    if (intercoolerIds.includes(optionId)) {
      const withoutOtherIntercooler = withoutStock.filter((id) => !intercoolerIds.includes(id));
      return withoutStock.includes(optionId) ? withoutOtherIntercooler : [...withoutOtherIntercooler, optionId];
    }

    return withoutStock.includes(optionId)
      ? withoutStock.filter((id) => id !== optionId)
      : [...withoutStock, optionId];
  }

  return selected.includes(optionId)
    ? selected.filter((id) => id !== optionId)
    : [...selected, optionId];
}

function isStepComplete(step) {
  if (!isStepVisible(step)) {
    return true;
  }

  if (step.type === "summary") {
    return true;
  }

  if (step.type === "fields") {
    return areRequiredFieldsComplete(step);
  }

  if (step.type !== "options") {
    return true;
  }

  const answer = state.answers[step.id];
  return Array.isArray(answer) ? answer.length > 0 : Boolean(answer);
}

function getMaxVisibleStepIndex() {
  const visibleSteps = getVisibleSteps();
  for (const step of visibleSteps) {
    if (!isStepComplete(step)) {
      return advisorData.steps.indexOf(step);
    }
  }

  return advisorData.steps.indexOf(visibleSteps[visibleSteps.length - 1]);
}

function getMaxVisibleStepPosition() {
  const visibleSteps = getVisibleSteps();
  const maxVisibleStep = getMaxVisibleStepIndex();
  return visibleSteps.findIndex((step) => advisorData.steps.indexOf(step) === maxVisibleStep);
}

function getVisibleSteps() {
  return advisorData.steps.filter(isStepVisible);
}

function isStepVisible(step) {
  if (!step) return false;

  if (step.visibleForModel) {
    return state.answers.car === step.visibleForModel;
  }

  return true;
}

function isContactReady(step = advisorData.steps.find((item) => item.id === "contact")) {
  return areRequiredFieldsComplete(step);
}

function areRequiredFieldsComplete(step) {
  return step.fields
    .filter((field) => field.required)
    .every((field) => String(state.answers[field.id] || "").trim().length > 0);
}

function getVisibleStepIndex(originalIndex) {
  return getVisibleSteps().findIndex((step) => advisorData.steps.indexOf(step) === originalIndex);
}

function ensureCurrentStepIsVisible() {
  if (isStepVisible(advisorData.steps[state.currentStep])) return;
  state.currentStep = getClosestVisibleStepIndex(state.currentStep, 1);
}

function getClosestVisibleStepIndex(index, direction) {
  const stepDirection = direction >= 0 ? 1 : -1;
  for (let nextIndex = index; nextIndex >= 0 && nextIndex < advisorData.steps.length; nextIndex += stepDirection) {
    if (isStepVisible(advisorData.steps[nextIndex])) return nextIndex;
  }

  return getVisibleSteps().length ? advisorData.steps.indexOf(getVisibleSteps()[0]) : 0;
}

function getAdjacentVisibleStepIndex(index, direction) {
  const stepDirection = direction >= 0 ? 1 : -1;
  for (let nextIndex = index + stepDirection; nextIndex >= 0 && nextIndex < advisorData.steps.length; nextIndex += stepDirection) {
    if (isStepVisible(advisorData.steps[nextIndex])) return nextIndex;
  }

  return index;
}

function renderList(items, className = "") {
  return `<ul class="${className}">${items.map((item) => `<li>${escapeHtml(item)}</li>`).join("")}</ul>`;
}

function renderPartList(items, type) {
  return `<ul class="part-list part-list--${escapeHtml(type)}">${items.map((item) => `<li>${escapeHtml(item)}</li>`).join("")}</ul>`;
}

function renderPerformanceMetric(label, value) {
  return `<article class="performance-card">
    <span>${escapeHtml(label)}</span>
    <strong>${escapeHtml(value)}</strong>
  </article>`;
}

function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

stepTabs.addEventListener("click", (event) => {
  const button = event.target.closest("[data-step]");
  if (!button) return;
  goToStep(Number(button.dataset.step));
});

stepContent.addEventListener("click", (event) => {
  const dynoPreviewButton = event.target.closest("[data-dyno-preview]");
  if (dynoPreviewButton) {
    openDynoPreview(dynoPreviewButton.dataset.dynoPreview);
    return;
  }

  const button = event.target.closest("[data-option]");
  if (!button) return;
  updateOption(button.dataset.option);
});

document.addEventListener("click", (event) => {
  if (event.target.matches(".image-preview") || event.target.closest("[data-close-preview]")) {
    closeDynoPreview();
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    closeDynoPreview();
  }
});

stepContent.addEventListener("input", (event) => {
  const field = event.target.closest("[data-field]");
  if (!field) return;
  updateField(field.dataset.field, field.value);
  updateFieldControls();
});

stepContent.addEventListener("change", (event) => {
  const field = event.target.closest("[data-field]");
  if (!field) return;
  updateField(field.dataset.field, field.value);
  updateFieldControls();
});

advisorForm.addEventListener("submit", (event) => {
  const step = advisorData.steps[state.currentStep];
  if (step?.id !== "contact" || !isContactReady(step)) {
    event.preventDefault();
    return;
  }

  const bodyField = advisorForm.querySelector('[name="contact[body]"]');
  if (bodyField) {
    bodyField.value = buildContactBody();
  }
});

prevButton.addEventListener("click", () => {
  goToStep(getAdjacentVisibleStepIndex(state.currentStep, -1));
});

nextButton.addEventListener("click", () => {
  if (!isStepComplete(advisorData.steps[state.currentStep])) {
    return;
  }

  if (getAdjacentVisibleStepIndex(state.currentStep, 1) === state.currentStep) {
    submitContactForm();
    return;
  }

  goToStep(getAdjacentVisibleStepIndex(state.currentStep, 1));
});

render();
